import { BrokersSocietiesWithUsers } from "@dune/types";

/**
 * Constructs a full address string from address components
 * @param address - The address object containing streetNumber, streetName, postalCode, and city
 * @returns A formatted address string with all non-empty components joined by spaces
 */
export const getFullAddress = (
	address: BrokersSocietiesWithUsers["headOfficeAddress"],
): string => {
	if (!address) return "";
	return [
		address.streetNumber,
		address.streetName,
		address.postalCode,
		address.city,
	]
		.filter(Boolean)
		.join(" ");
};

export const normalizeAddress = (
	streetNumber?: string | null,
	streetName?: string | null,
	postalCode?: string | null,
	city?: string | null,
): string => {
	return [streetNumber, streetName, postalCode, city]
		.filter(Boolean)
		.map((val) => val?.trim().toLowerCase() || "")
		.join(" ");
};

